















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  name: 'TableMenu',
  data() {
    return {
      titleUserActive: 'Most Active User Acess App',
      titleCategoryMaterials: 'Most User Report PKT',
      titleMaterialAccess: 'Most Active Material Access',
      alignCard: 'center',
      fieldsMaterialAccess: [
        { key: 'no' },
        { key: 'category' },
        { key: 'numberAccess' },
      ],
      fieldsUserActive: [
        { key: 'no' },
        { key: 'salesCode' },
        { key: 'salesName' },
        { key: 'dealerCode' },
        { key: 'dealerName' },
        { key: 'dealerCity' },
        { key: 'totalAccess' },
      ],
      fieldsCategoryMaterials: [
        { key: 'no' },
        { key: 'salesCode' },
        { key: 'salesName' },
        { key: 'dealerName' },
        { key: 'totalReport' },
      ],
    }
  },
})
export default class extends Vue {
  @Prop({}) public PktData
  @Prop({}) public UserData
  @Prop({}) public MaterialAcess: any | undefined
  @Prop({}) public hasSearch: boolean | undefined
}
